import React from 'react';
import { Spring, animated } from 'react-spring';
import { Link } from 'react-router-dom';
import cn from 'classnames';

import styles from './style.css';

const AnimatedLink = animated(Link);

const Jobs = () => (
  <div className={styles.jobs}>
    <Spring native from={{ opacity: 0 }} to={{ opacity: 1 }}>
      {style => (
        <animated.div
          style={style}
          className={cn(
            styles.jobs__description,
            styles.jobs__description__main
          )}
        >
          <p>
            Join our award winning app design and development studio in the
            heart of Cluj-Napoca. We put client first by having each member of
            our team act as an owner of what is being delivered to clients.
          </p>
        </animated.div>
      )}
    </Spring>
    <Spring
      native
      from={{ opacity: 0, transform: 'translateX(-50%)' }}
      to={{ opacity: 1, transform: 'translateX(0%)' }}
      delay={500}
    >
      {style => (
        <AnimatedLink
          style={style}
          to="/jobs/ios-senior"
          className={styles.jobs__offer}
        >
          <span>Senior iOS Developer</span>
          <span>Apply Now!</span>
        </AnimatedLink>
      )}
    </Spring>
    <Spring
      native
      from={{ opacity: 0, transform: 'translateX(-50%)' }}
      to={{ opacity: 1, transform: 'translateX(0%)' }}
      delay={500}
    >
      {style => (
        <AnimatedLink
          style={style}
          to="/jobs/ios-junior"
          className={styles.jobs__offer}
        >
          <span>Junior iOS Developer</span>
          <span>Apply Now!</span>
        </AnimatedLink>
      )}
    </Spring>
    <Spring
      native
      from={{ opacity: 0, transform: 'translateX(-50%)' }}
      to={{ opacity: 1, transform: 'translateX(0%)' }}
      delay={500}
    >
      {style => (
        <AnimatedLink
          style={style}
          to="/jobs/android"
          className={styles.jobs__offer}
        >
          <span>Android Developer</span>
          <span>Apply Now!</span>
        </AnimatedLink>
      )}
    </Spring>
  </div>
);

export default Jobs;
